import { createPortal } from 'react-dom'

const Portal = ({ component, elementId }) => {
  const parent = document.getElementById(elementId)

  return createPortal(component, parent)
}

export default Portal
